import { getQueryString, handleError, page_size } from 'api/apiUtils';
import { createAxiosInstance } from 'api/apiUtils';
import { refreshRoutesAndConnections } from 'api/cacheRefresh';

export async function getSources(token: string, query: object) {
  const axiosInstance = await createAxiosInstance(token);
  const query_string = getQueryString(query);
  try {
    const resp = await axiosInstance.get(
      '/v2/sources/?pager=limit&limit=' + page_size + '&' + query_string,
    );
    return resp.data;
  } catch (err) {
    handleError(err);
  }
}

export async function getSourcesForRoute(
  token: string,
  provider_id: string,
  query: object,
) {
  const axiosInstance = await createAxiosInstance(token);
  const query_string = getQueryString(query);
  try {
    const resp = await axiosInstance.get(
      '/v2/sources/?pager=limit&limit=' +
        page_size +
        '&provider=' +
        provider_id +
        '&' +
        query_string,
    );
    return resp.data;
  } catch (err) {
    handleError(err);
  }
}
// Create a source by hand, for a device that has never reported (GUNDI-5178). Rethrows
// so the caller can read the body: 409 when the provider already has that external_id,
// 400 when the provider is missing or not one of the caller's.
export async function createSource(
  token: string,
  payload: { provider: string; external_id: string; name?: string },
) {
  const axiosInstance = await createAxiosInstance(token);
  const resp = await axiosInstance.post('/v2/sources/', payload);
  // A new device lands in the route's source list and in the rules editor's
  // pickers, both served from the shared route cache.
  refreshRoutesAndConnections();
  return resp.data;
}
